'use strict';

export default class Fetch {
  constructor(params) {
    const {action, ...rest} = params;

    this.action = action;
    this.formData = rest;
    this.form_submit = '';

    if(this.formData.form_id) {
      this.form_submit = document.getElementById(this.formData.form_id);
      delete this.formData.form_id;
    }

    return this.#run();
  }

  async #run() {
    try {

      let formData = new FormData();
      if(this.form_submit !== '') {
        formData = new FormData(this.form_submit);
      }

      formData.append('action', `twer_${this.action}`);
      for (const property in this.formData) {
        formData.append(property, this.formData[property]);
      }

      let ajaxUrl = window?.twer_ajax?.url;
      if(typeof ajaxUrl === 'undefined') {
        ajaxUrl = window?.treweler_params.ajax_url;
      }

      const response = await fetch(ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responsve = await response.json();

      return responsve;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

}
